import React from 'react'

import { connect } from 'react-redux'
import classnames from 'classnames'

import Configurator from '../../../configurator'

import Event from '../../../front/components/shared/events/event-box'

import { fetchEvents } from '../../../front/components/shared/events/fetch-events'
import Map, {
    parseMarkers,
    hoverMarkers,
    DEFAULT_PREVIEW_OPTIONS,
} from '../../shared/map'
import { i18n } from '../../../validator'
import Loader from '../../../front/components/shared/loader'
import Link from '../../../front/components/shared/sn-link'

@i18n()
class ForthcomingEvents extends Configurator {
    constructor(props) {
        super(props)

        this.state = {
            events: {
                today: [],
                tomorrow: [],
                all: [],
            },
            markers: [],
            ready: false,
        }

        this.map = React.createRef()
        this.listing = React.createRef()
    }

    toggleHoverMarker = (id, isHovered = false) => {
        this.setState({ markers: hoverMarkers([...this.state.markers], id, isHovered) })
    }

    getEvents() {
        return fetchEvents(true, 18, true).then(res => {
            this.setState({ events: {
                today: [],
                tomorrow: [],
                later: [],
                all: res ? res.events : [],
            } })

            this.groupEventsByTime()

            this.setState({ ready: true })

            const mapStyle = this?.map?.style
            if (mapStyle) {
                mapStyle.height = `${((this?.listing?.offsetHeight || 0) + 20)}px`
            }

            return new Promise(resolve => resolve(res))
        })
    }

    componentDidMount() {
        this.getEvents().then(dataEvents => {
            const markers = parseMarkers({ data: dataEvents.events }, 'event')
            this.setState({ markers })
        })
    }

    groupEventsByTime() {
        const today = moment()
        const tomorrow = moment().add(1, 'd')
        const { events } = this.state

        const todayEvents = events.all.filter(item => moment.utc(item.start_date).local().isSame(today, 'days'))
        const tomorrowEvents = events.all.filter(item => moment.utc(item.start_date).local().isSame(tomorrow, 'days'))
        const laterEvents = events.all.filter(item => moment.utc(item.start_date).local().isAfter(tomorrow, 'days'))

        this.setState(() => ({
            events: {
                today: todayEvents,
                tomorrow: tomorrowEvents,
                later: laterEvents,
                all: this.state.events.all,
            },
        }))
    }

    render() {
        const {
            events,
            ready,
            markers,
        } = this.state

        const { t } = this.props

        return (
            <div className="Forthcoming-events" id="udalosti">
                <div className="position-relative">
                    <div ref={el => this.listing = el} className={classnames({
                        'Forthcoming-events__listing': true,
                        'w-100 h-100': !ready,
                    })} style={ !ready ? { left: '0' } : {}}>
                        {ready &&
                            <div>
                                {events.today.length > 0 && this.renderForDay('today')}
                                {events.tomorrow.length > 0 && this.renderForDay('tomorrow')}
                                {events.later.length > 0 && this.renderForDay('later')}

                                <hr className="Forthcoming-events__listing-separator" />
                                <Link to="/udalosti" className="Forthcoming-events__show-all">
                                    {t('showAllEvents')}
                                </Link>
                            </div>
                        }
                        {!ready &&
                            <div className="d-flex justify-content-center align-items-center w-100 h-100">
                                <Loader />
                            </div>
                        }
                    </div>
                    <Map
                        markers={markers}
                        fitBounds={false}
                        containerElement={<div className="Forthcoming-events__map" ref={el => this.map = el} />}
                        options={DEFAULT_PREVIEW_OPTIONS()}
                    />
                </div>
            </div>
        )
    }

    renderForDay(day) {
        const { events: eventState } = this.state
        const { t } = this.props
        let events = eventState[day]

        const showLaterEventsTitle = eventState.today.length !== 0
            || eventState.tomorrow.length !== 0

        return (
            <div>
                <h3 className="Forthcoming-events__time">
                    {day === 'today' && t('today')}
                    {day === 'tomorrow' && t('tomorrow')}
                    {showLaterEventsTitle && day === 'later' && t('nextEvents')}
                </h3>

                <div className="Forthcoming-events__row mx-auto">
                    {this.renderEvents(events)}
                </div>
            </div>
        )
    }

    renderEvents(events) {
        return events.map(event =>
            <div className="mgb-10 mgr-15" key={event.id}>
                <Event
                    event={event}
                    toggleHoverMarker={this.toggleHoverMarker}
                    mainClassName="event"
                />
            </div>
        )
    }
}

function mapStateToProps(state) {
    return { events: state.app.events }
}

export default connect(mapStateToProps)(ForthcomingEvents)
